import { createContext, useContext } from 'react';
import { UseStepperProps, useStepper } from '../Hooks';

export const StepperContext = createContext<
  ReturnType<typeof useStepper>
| undefined>(undefined);

export function useStepperContext() {
  const value = useContext(StepperContext);

  if (value === undefined) {
    throw new Error('Stepper Context is undefined');
  }

  return value;
}
